import { render, staticRenderFns } from "./Tour2.vue?vue&type=template&id=37d09d3f&scoped=true&"
import script from "./Tour2.vue?vue&type=script&lang=js&"
export * from "./Tour2.vue?vue&type=script&lang=js&"
import style0 from "./Tour2.vue?vue&type=style&index=0&id=37d09d3f&prod&lang=scss&scoped=true&"
import style1 from "./Tour2.vue?vue&type=style&index=1&id=37d09d3f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d09d3f",
  null
  
)

export default component.exports